<template>
  <the-button
    :to="to"
    :href="href"
    text
    icon
    :class="{
      'nav-active': active,
      mobile: $vuetify.display.mobile,
      desktop: !$vuetify.display.mobile
    }"
    :tab-index="tabIndex"
  >
    <v-badge v-if="badgeCount" color="rgba(0,0,0,0)" :class="{ wider: badgeCount > 9 }">
      <template #badge>
        <div
          class="d-flex align-center justify-center fill-height color-top-bar-background"
          :class="active ? 'background-top-bar-text' : 'background-top-bar-tint'"
        >
          {{ badgeCount > 99 ? "99+" : badgeCount }}
        </div>
      </template>

      <slot v-if="active" name="active" />
      <slot v-else name="inactive" />
    </v-badge>
    <slot v-else-if="active" name="active" />
    <slot v-else name="inactive" />
  </the-button>
</template>

<script>
export default {
  props: {
    badgeCount: {
      type: Number,
      default: null
    },
    tabIndex: {
      type: Number,
      default: null
    },
    to: {
      type: Object,
      default: null
    },
    href: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  transition: none;
  border-radius: 0 !important;

  &.mobile {
    :deep(.v-btn__overlay) {
      display: none;
    }
  }

  &.desktop::before {
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    color: var(--top-bar-tint) !important;
  }

  &.nav-active.desktop::before {
    background-color: var(--top-bar-tint-5) !important;
    border-bottom: 2px solid var(--top-bar-tint);
    opacity: 1 !important;
  }

  &.desktop:hover::before,
  &.desktop:focus-visible::before {
    background-color: var(--top-bar-tint-10) !important;
  }

  &.nav-active.desktop,
  &.desktop:hover,
  &.desktop:focus-visible {
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 0 !important;
      opacity: 1 !important;
    }
  }

  &::before {
    transition: none;
  }

  :deep(.v-badge) {
    .v-badge__badge {
      font-size: var(--font-size-small);
      width: 18px;
      height: 18px;
      padding: 0;

      div {
        border-radius: var(--rounded-circle);
        width: 18px;
        height: 18px;
      }
    }

    &.wider {
      .v-badge__badge {
        width: auto;
        right: -10px;
        // fixes the difference between messaging and inbox bubble
        line-height: normal;

        div {
          padding: 0 5px;
          border-radius: 15px;
          width: auto;
        }
      }
    }
  }
}
</style>
